import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DashboardMessageService {

  private messageSource = new BehaviorSubject('default message');
  currentMessage = this.messageSource.asObservable();
  isSearchOpen = new Subject<any>();


  constructor() { }

  changeMessage(message: string) {
    if (!message)
      return
    this.messageSource.next(message)
  }

  changeColor(mode:any){
    if(mode == 'dark'){
      // document.documentElement.style.setProperty("--black", "white");
    }
  }

  getIsSearchOpen(): Observable<any>{
    return this.isSearchOpen.asObservable();
  }
}
